// src/components/DietAssessment/components/AssessmentStepErrorBoundary.js
import React from 'react';
import { Box, Typography, Button, Tooltip } from '@mui/material';

class AssessmentStepErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('AssessmentStepErrorBoundary caught an error:', error, errorInfo);
    this.setState({ errorInfo });
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };

  handleGoBack = () => {
    if (this.props.onGoBack) {
      this.props.onGoBack();
    } else {
      window.history.back();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ textAlign: 'center', p: 4 }}>
          <Typography
            variant="h4"
            color="error"
            gutterBottom
          >
            Step Error
          </Typography>
          <Typography
            variant="body1"
            sx={{ mb: 2 }}
          >
            There was an error loading this step. You can try reloading the step or go back to the previous step.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={this.handleRetry}
            sx={{ mr: 2 }}
          >
            Retry
          </Button>
          <Button
            variant="outlined"
            color="secondary"
            onClick={this.handleGoBack}
          >
            Go Back
          </Button>
          {this.state.error && (
            <Box sx={{ mt: 2 }}>
              <Typography
                variant="caption"
                color="textSecondary"
              >
                <Tooltip title={this.state.errorInfo?.componentStack || ''}>
                  <span>{this.state.error.toString()}</span>
                </Tooltip>
              </Typography>
            </Box>
          )}
        </Box>
      );
    }
    return this.props.children;
  }
}

export default AssessmentStepErrorBoundary;
